// import React, { useState, useContext } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { Container, TextField, Button, Typography, Box, CircularProgress } from '@mui/material';
// import { AuthContext } from '../contexts/AuthContext';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

// const Login = () => {
//   const { setAuth } = useContext(AuthContext);
//   const [formData, setFormData] = useState({ username: '', password: '' });
//   const [loading, setLoading] = useState(false); // Loading state
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true); // Start loading
//     try {
//       const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, formData);
//       // Update context and localStorage with token, role, and username
//       setAuth({
//         token: response.data.token,
//         role: response.data.role,
//         username: response.data.username,
//         userId: response.data.userID,  
//       });
//       localStorage.setItem('userId', response.data.userID);

//       alert('Login successful!');
//       navigate('/');
//     } catch (error) {
//       console.error('Login error:', error);
//       alert('Login failed. Please check your credentials.');
//     } finally {
//       setLoading(false); // Stop loading
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         minHeight: '100vh',
//         backgroundImage: 'url(https://source.unsplash.com/random?education)', // Background image
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//       }}
//     >
//       <Container maxWidth="sm">
//         <Box
//           sx={{
//             p: 4,
//             bgcolor: 'background.paper',
//             borderRadius: 2,
//             boxShadow: 3,
//             textAlign: 'center',
//             background: 'linear-gradient(145deg, #ffffff, #f0f0f0)', // Gradient background
//           }}
//         >
//           <LockOutlinedIcon sx={{ fontSize: 50, color: 'primary.main', mb: 2 }} /> {/* Lock icon */}
//           <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
//             Login
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <TextField
//               label="Username"
//               name="username"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               onChange={handleChange}
//               required
//               InputProps={{
//                 startAdornment: (
//                   <PersonOutlineOutlinedIcon sx={{ color: 'action.active', mr: 1 }} /> // Username icon
//                 ),
//               }}
//             />
//             <TextField
//               label="Password"
//               name="password"
//               type="password"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               onChange={handleChange}
//               required
//               InputProps={{
//                 startAdornment: (
//                   <LockOutlinedIcon sx={{ color: 'action.active', mr: 1 }} /> // Password icon
//                 ),
//               }}
//             />
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               fullWidth
//               sx={{ mt: 2, py: 1.5, fontSize: '1rem', fontWeight: 'bold' }}
//               disabled={loading} // Disable button when loading
//             >
//               {loading ? <CircularProgress size={24} /> : 'Login'} {/* Show spinner when loading */}
//             </Button>
//           </form>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Login;


import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const Login = () => {
  const { setAuth } = useContext(AuthContext);
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await axios.post(`${apiUrl}/api/auth/login`, formData);

      // Update context and localStorage with token, role, and username
      setAuth({
        token: response.data.token,
        role: response.data.role,
        username: response.data.username,
        userId: response.data.userID,
      });
      localStorage.setItem('userId', response.data.userID);

      setSnackbar({ open: true, message: 'Login successful! Redirecting...', severity: 'success' });
      setTimeout(() => navigate('/'), 1500);
    } catch (error) {
      console.error('Login error:', error);

      setSnackbar({
        open: true,
        message: error.response.data.message,
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <div className="login-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .login-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .login-container::before {
          content: '';
          position: absolute;
          top: 10%;
          right: 15%;
          width: 200px;
          height: 200px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 6s ease-in-out infinite;
        }

        .login-container::after {
          content: '';
          position: absolute;
          bottom: 10%;
          left: 10%;
          width: 150px;
          height: 150px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 4s ease-in-out infinite;
          animation-delay: 2s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes slideInFromBottom {
          from { 
            opacity: 0; 
            transform: translateY(100px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(102, 126, 234, 0.3); }
          50% { box-shadow: 0 0 40px rgba(102, 126, 234, 0.6), 0 0 60px rgba(118, 75, 162, 0.4); }
        }

        .decorative-element-1 {
          position: absolute;
          top: 20%;
          left: 20%;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          animation: pulse 4s ease-in-out infinite;
        }

        .decorative-element-2 {
          position: absolute;
          bottom: 30%;
          right: 25%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: pulse 3s ease-in-out infinite;
          animation-delay: 1s;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.2); }
        }

        .login-wrapper {
          max-width: 450px;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .login-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.8s ease-out;
          position: relative;
          overflow: hidden;
        }

        .login-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .login-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }

        .login-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: white;
          box-shadow: 0 8px 32px rgba(102, 126, 234, 0.4);
          animation: glow 3s ease-in-out infinite;
          transition: transform 0.3s ease;
        }

        .login-icon:hover {
          transform: scale(1.05);
        }

        .login-title {
          font-size: 2.5rem;
          font-weight: 900;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .login-subtitle {
          color: #6b7280;
          font-size: 1rem;
          font-weight: 500;
        }

        .form-group {
          margin-bottom: 2rem;
          position: relative;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.95rem;
        }

        .input-container {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 1rem;
          z-index: 2;
          color: #9ca3af;
          transition: color 0.3s ease;
        }



          .password-toggle {
  position: absolute;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 0.25rem;
  z-index: 3;
}

.password-toggle:hover {
  color: #667eea;
}




        .form-input {
          width: 100%;
          padding: 1.25rem 1.25rem 1.25rem 3.5rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          box-sizing: border-box;
        }

        .form-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .form-input:focus + .input-icon {
          color: #667eea;
        }

        .login-btn {
          width: 100%;
          padding: 1.5rem 2rem;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          border: none;
          border-radius: 16px;
          font-size: 1.1rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4);
          margin-top: 1rem;
        }

        .login-btn:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(102, 126, 234, 0.5);
        }

        .login-btn:active:not(:disabled) {
          transform: translateY(-1px);
        }

        .login-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .loading-spinner {
          width: 24px;
          height: 24px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .snackbar {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1rem 2rem;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          z-index: 1000;
          animation: slideInFromBottom 0.3s ease-out;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          max-width: 400px;
        }

        .snackbar.success {
          background: rgba(16, 185, 129, 0.9);
        }

        .snackbar.error {
          background: rgba(239, 68, 68, 0.9);
        }

        .snackbar.warning {
          background: rgba(245, 158, 11, 0.9);
        }

        .snackbar.info {
          background: rgba(59, 130, 246, 0.9);
        }

        .snackbar-close {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          opacity: 0.8;
        }

        .snackbar-close:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        /* Additional visual elements */
        .brand-logo {
          position: absolute;
          top: 2rem;
          left: 2rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: white;
          font-weight: 700;
          font-size: 1.25rem;
        }

        .logo-icon {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .login-container {
            padding: 1rem 0.5rem;
          }
          
          .login-card {
            padding: 2rem 1.5rem;
          }

          .login-icon {
            width: 70px;
            height: 70px;
          }

          .login-title {
            font-size: 2rem;
          }

          .brand-logo {
            position: relative;
            top: 0;
            left: 0;
            justify-content: center;
            margin-bottom: 2rem;
          }

          .snackbar {
            left: 1rem;
            right: 1rem;
            transform: none;
            max-width: none;
          }
        }

        /* Focus accessibility improvements */
        .form-input:focus-visible {
          outline: 2px solid #667eea;
          outline-offset: 2px;
        }

        .login-btn:focus-visible {
          outline: 2px solid #ffffff;
          outline-offset: 2px;
        }
      `}</style>

      {/* Decorative Elements */}
      <div className="decorative-element-1"></div>
      <div className="decorative-element-2"></div>

      {/* Brand Logo
      <div className="brand-logo">
        <div className="logo-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z" />
          </svg>
        </div>
        EXAM ACE
      </div> */}

      <div className="login-wrapper">
        <div className="login-card">
          <div className="login-header">
            <div className="login-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11H16V18H8V11H9.2V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.4,8.7 10.4,10V11H13.6V10C13.6,8.7 12.8,8.2 12,8.2Z" />
              </svg>
            </div>
            <div className="login-title">Welcome Back</div>
            <div className="login-subtitle">Sign in to your account to continue</div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Username</label>
              <div className="input-container">
                <input
                  type="text"
                  name="username"
                  className="form-input"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Enter your username"
                  required
                />
                <svg
                  className="input-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                </svg>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="input-container">
                {/* <input
                  type="password"
                  name="password"
                  className="form-input"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                /> */}
                 <input
    type={showPassword ? "text" : "password"}
    name="password"
    className="form-input"
    value={formData.password}
    onChange={handleChange}
    placeholder="Enter your password"
    required
  />

  {/* Eye Button */}
  <button
    type="button"
    className="password-toggle"
    onClick={() => setShowPassword(!showPassword)}
  >
    {showPassword ? (
      // Eye Off Icon
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12,7C9.79,7 8,8.79 8,11C8,11.17 8.03,11.33 8.05,11.5L5.55,9C7,7.6 9.34,7 12,7C14.03,7 16.16,7.47 18.32,8.41L20,7.24C17.36,5.92 14.56,5 12,5C8.61,5 5.5,6.28 3,8.5L1.39,6.88L0,8.27L21.73,30L23.12,28.61L19.78,25.27C21.7,23.74 23.27,21.82 24,19.73C23,17.22 21.11,15.2 18.64,14.14L15.9,16.88C15.96,17.08 16,17.28 16,17.5C16,19.71 14.21,21.5 12,21.5C10.56,21.5 9.3,20.83 8.5,19.77L6.05,22.23C7.61,23.91 9.7,25 12,25C15.39,25 18.5,23.72 21,21.5C22.61,20.11 23.84,18.38 24.61,16.5C23.84,14.62 22.61,12.89 21,11.5L17.61,14.89C17.83,15.39 18,15.93 18,16.5C18,18.71 16.21,20.5 14,20.5C13.28,20.5 12.61,20.32 12,20.03L10.42,21.61C11.16,22 11.94,22.2 12.75,22.2C13.94,22.2 15.06,21.84 16.03,21.19L22.12,27.27L23.51,25.88L1.73,4.11L0.34,5.5L3.68,8.84C2.73,9.53 1.94,10.36 1.39,11.31C2.16,13.19 3.39,14.92 5,16.31C6.6,17.7 8.61,18.94 10.86,19.63L8.11,22.38C7.07,21.39 6,20 5.14,18.47L3.73,20C5.5,23.14 8.5,25 12,25C15.5,25 18.5,23.14 20.27,20C21.61,17.64 22.61,14.91 23,12C22.24,9.45 20.79,7.2 18.76,5.62C17.54,6.63 16.34,7.17 15.12,7.17C13.16,7.17 11.38,6.61 9.83,5.76C10.45,6.33 10.77,7.16 10.77,8C10.77,10.21 8.98,12 6.77,12C6.03,12 5.34,11.79 4.73,11.47Z"/>
      </svg>
    ) : (
      // Eye Icon
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5M12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"/>
      </svg>
    )}
  </button>
                <svg
                  className="input-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11H16V18H8V11H9.2V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.4,8.7 10.4,10V11H13.6V10C13.6,8.7 12.8,8.2 12,8.2Z" />
                </svg>
              </div>
            </div>

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="loading-spinner"></div>
                  Signing In...
                </>
              ) : (
                <>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M10,17V14H3V10H10V7L15,12L10,17M10,2H19A2,2 0 0,1 21,4V20A2,2 0 0,1 19,22H10A2,2 0 0,1 8,20V18H10V20H19V4H10V6H8V4A2,2 0 0,1 10,2Z" />
                  </svg>
                  Sign In
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      {/* Snackbar Notification */}
      {snackbar.open && (
        <div className={`snackbar ${snackbar.severity}`}>
          <span>{snackbar.message}</span>
          <button className="snackbar-close" onClick={closeSnackbar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default Login;
